<template>
  <div>
    <v-col cols="12">
      <v-row class="justify-space-between">
        <v-col cols="4">
          <v-btn color="primary" dark class="px-8" @click="dialog = true">
            Nuevo factor
          </v-btn>
          <v-dialog v-model="dialog" persistent max-width="500px">
            <v-card>
              <v-card-title
                >{{
                  editedItem.idFactor == 0 ? "Crear Nuevo " : "Editar "
                }}
                factor</v-card-title
              >
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.departamento"
                        label="Departamento"
                        clearable
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.nombre"
                        label="Nombre"
                        clearable
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" v-if="errores.length > 0">
                      <ul>
                        <li
                          v-for="(error, idx) in errores"
                          :key="'e-' + idx"
                          class="red--text"
                        >
                          {{ error }}
                        </li>
                      </ul>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="success"
                  :disabled="saving"
                  @click="cerrarDialog()"
                  >Cancelar</v-btn
                >
                <v-btn
                  text
                  color="error"
                  :disabled="saving"
                  :loading="saving"
                  @click="saveChanges()"
                  >Guardar</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogDelete" persistent max-width="40%">
            <v-card>
              <v-card-text>
                <p class="text-h5 pt-4 font-weight-medium text--primary">
                  ¿Está seguro que desea eliminar esta Factor?
                </p>
                <p class="subtitle-1 text--primary">
                  Esta acción no se puede revertir y será permanente.
                </p>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="success"
                  :disabled="deleting"
                  @click="cerrarDialog()"
                  >Cancelar</v-btn
                >
                <v-btn
                  text
                  color="error"
                  :disabled="deleting"
                  :loading="deleting"
                  @click="deleteFactor()"
                  >Eliminar</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
        <v-col cols="12">
          <v-data-table
            :headers="Header"
            :items="factores"
            :loading="loading"
            class="elevation-1"
          >
            <template v-slot:item.subFactores="{ item }">
              <span v-if="item.subFactores.length == 0">N/A</span>
              <div v-for="(sub, i) in item.subFactores" :key="i">
                {{ sub.nombre }}
              </div>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip bottom color="black" class="white--text">
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    small
                    class="mr-2"
                    @click="showDialogEdit(item)"
                  >
                    edit
                  </v-icon>
                </template>
                <span class="white--text">Editar</span>
              </v-tooltip>
              <v-tooltip bottom color="black" class="white--text">
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    small
                    class="mr-2"
                    @click="showDialogDelete(item)"
                  >
                    delete
                  </v-icon>
                </template>
                <span class="white--text">Eliminar</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      Header: [
        {
          text: "Departamento",
          align: "center",
          value: "departamento",
        },
        {
          text: "Nombre",
          align: "center",
          value: "nombre",
        },
        {
          text: "Subfactores",
          align: "center",
          tipo: "objeto",
          value: "subFactores",
        },
        {
          text: "Acciones",
          align: "center",
          width: "10%",
          value: "actions",
        },
      ],
      factores: [],
      errores: [],
      dialog: false,
      editedItem: {
        idFactor: 0,
        departamento: null,
        nombre: null,
      },
      saving: false,
      loading: false,
      dialogDelete: false,
    };
  },
  mounted() {
    this.initialize();
  },
  methods: {
    validate() {
      this.errores = [];

      if (this.editedItem.departamento == null) {
        this.errores.push("El departamento es obligatorio");
      } else if (this.editedItem.departamento == "") {
        this.errores.push("El departamento es obligatorio");
      } else if (this.editedItem.departamento.length < 5) {
        this.errores.push("El departamento debe tener mínimo 5 caracteres");
      }

      if (this.editedItem.nombre == null) {
        this.errores.push("El nombre es obligatorio");
      } else if (this.editedItem.nombre == "") {
        this.errores.push("El nombre es obligatorio");
      } else if (this.editedItem.nombre.length < 5) {
        this.errores.push("El nombre debe tener mínimo 5 caracteres");
      }

      return this.errores.length == 0;
    },
    cerrarDialog() {
      this.dialog = false;
      this.dialogDelete = false;
      this.editedItem = { ...this.defaultEditedItem };
      this.errores = [];
    },
    showDialogEdit(item) {
      this.editedItem = { ...item };
      this.dialog = true;
    },
    showDialogDelete(item) {
      this.editedItem = { ...item };
      this.dialogDelete = true;
    },
    deleteFactor() {
      this.deleting = true;
      axios
        .put(`/Factores/EliminarFactor/${this.editedItem.idFactor}`)
        .then(() => {
          this.deleting = false;
          this.cerrarDialog();
          this.initialize();
        })
        .catch((error) => {
          this.deleting = false;
          console.log(error);
        });
    },
    saveChanges() {
      if (!this.validate()) return;

      this.saving = true;
      axios({
        url:
          this.editedItem.idFactor == 0
            ? "/Factores/CrearFactor"
            : `/Factores/EditarFactor/${this.editedItem.idFactor}`,
        method: this.editedItem.idFactor == 0 ? "POST" : "PUT",
        data: this.editedItem,
      })
        .then(() => {
          this.saving = false;
          this.cerrarDialog();
          this.initialize();
        })
        .catch((error) => {
          this.saving = false;
          if (error.response) {
            if (error.response.status == 409) {
              this.errores.push(
                "Existe una Causa con el mismo Nombre o Código"
              );
            }
          }
          console.log(error);
        });
    },
    initialize() {
      this.getFactores();
    },
    getFactores() {
      this.loading = true;
      axios
        .get("/Factores/ListarBasico")
        .then((response) => {
          this.factores = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
